<template>
  <div class="modal fade" id="edit-user-profile">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{$t('profile_edit_title')}}</h5>

          <button type="button" class="close" data-bs-dismiss="modal" :aria-label="$t('close')">
            <span class="material-icons">close</span>
          </button>
        </div>

        <div class="modal-body">
          <div class="user-profiles-group mb-4">
            <div class="profile-cover text-center">
              <label class="profile-cover-avatar">
                <img
                  v-if="currentChatUser?.profile?.profile_picture_url"
                  class="avatar-img w-full"
                  :src="currentChatUser?.profile?.profile_picture_url"
                  :alt="$t('profile_image')"
                />

                <img
                  v-else
                  class="avatar-img"
                  src="@/assets/img/avatar/avatar-2.jpg"
                  :alt="$t('profile_image')"
                />

                <input type="file" id="avatar_upload_img" @change="changeProfilePicture"/>
                <span class="avatar-edit">
                  <img src="@/assets/img/icon/camera.svg" alt="Image" />
                </span>
              </label>
            </div>

            <div class="col-sm-12">
              <div class="pass-login">
                <label class="form-label">{{$t('profile_edit_chat_status_title')}} <small class="d-block text-gray">{{$t('profile_edit_chat_status_description')}}</small></label>
                <input type="text" class="form-control" v-model="form.chat_status"/>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6">
                <div class="pass-login">
                  <label class="form-label">{{$t('profile_edit_display_name')}} <small class="d-block text-gray">{{$t('profile_edit_visible_anyone')}}</small></label>
                  <input type="text" class="form-control" v-model="form.display_name" :disabled="true"/>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="pass-login">
                  <label class="form-label">{{$t('profile_edit_age')}} <small class="d-block text-gray">{{$t('profile_edit_visible_anyone')}}</small></label>
                  <input type="number" class="form-control" v-model="form.age" min="18" max="100" @change="onInputAge" :disabled="true"/>
                </div>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="pass-login">
                <label class="form-label">{{$t('profile_edit_bio_title')}} <small class="d-block text-gray">{{$t('profile_edit_bio_description')}}</small></label>
                <textarea class="form-control" v-model="form.bio_description"></textarea>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="pass-login">
                <label class="form-label">{{$t('profile_edit_dating_interest_title')}} <small class="d-block text-gray">{{$t('profile_edit_dating_interest_description')}}</small></label>
                <textarea class="form-control" v-model="form.dating_interest"></textarea>
              </div>
            </div>

            <hr>

            <form action="javascript:;">
              <div class="row">
                <div class="col-sm-12">
                  <div class="pass-login">
                    <label class="form-label">{{$t('profile_edit_email')}} <small class="d-block text-gray">{{$t('profile_edit_visible_you')}}</small></label>
                    <input type="text" class="form-control" :value="currentChatUser.email" disabled/>
                  </div>
                </div>

                <hr>

                <div class="col-sm-12">
                  <div class="pass-login">
                    <label class="form-label">{{$t('profile_edit_country')}} <small class="d-block text-gray">{{$t('profile_edit_best_matches')}}</small> </label>
                    <vue-select :settings="vueSelectSettings" :options="countriesOptions" :placeholder="$t('profile_edit_country')" v-model="form.country" :disabled="true"/>
                  </div>
                </div>

                <div class="col-sm-12 d-none">
                  <div class="pass-login">
                    <label class="form-label">{{$t('profile_edit_hobbies_title')}} <small class="d-block text-gray">{{$t('profile_edit_hobbies_description')}}</small></label>
                    <vue-select :settings="{...vueSelectSettings, multiple: true}" :options="hobbiesOptions" :placeholder="$t('profile_edit_hobbies_title')" v-model="form.hobbies"/>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="mute-chat-btn">
            <a id="btnClose" class="btn btn-secondary btn-block" data-bs-dismiss="modal" :aria-label="$t('close')">
              <i class="feather-x me-1"></i>{{ $t('cancel') }}
            </a>
            <a class="btn btn-primary btn-block" aria-label="Save" @click.prevent="submit">
              <i class="feather-check me-1"></i>{{$t('save')}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {dateFormat} from '@/util';

export default {
  props: {
    //
  },

  data() {
    return {
      form: {
        phone_number: '',
        display_name: '',
        age: '',
        chat_status: '',
        bio_description: '',
        country: '',
        city: '',
        dating_interest: '',
        hobbies: '',
      },
      profile_picture: '',
      vueSelectSettings: {
        allowClear: true,
        closeOnSelect: true,
      },
    };
  },

  computed: {
    ...mapGetters({
      authUser: 'auth/user',
      countries: 'misc/countries',
      hobbies: 'misc/hobbies',
      isOperator: 'isOperator',
      currentChatUser: 'chat/currentChatUser',
      operatorUsers: 'chat/internalUsers',
    }),

    currentUser() {
      if (this.isOperator && this.currentChatUser) {
        return this.currentChatUser;
      }

      return this.authUser;
    },

    countriesOptions() {
      return this.countries;
    },

    hobbiesOptions() {
      return this.hobbies;
    },
  },

  mounted() {
    this.resetForm();
  },

  created() {
    const user = this.operatorUsers.find(e => e.username === this.$route.params.username);
    if (user) {
      this.$store.commit('chat/setCurrentChatUser', user);
    }
  },

  methods: {
    dateFormat,

    onInputAge() {
      if (this.form.age < 18) {
        this.form.age = 18;
      }

      if (this.form.age > 100) {
        this.form.age = 100;
      }
    },

    async changeProfilePicture(event) {
      this.profile_picture = event.target.files[0];

      const user_id = this.currentChatUser ? this.currentChatUser.id : null;
      const r = await this.$store.dispatch('uploadImage', {
        user_id,
        category: 'profile_picture',
        picture: this.profile_picture,
      });

      if (r.success) {
        this.$emit('saved');
      }

      this.profile_picture = '';
      event.target.value = null;
    },

    /**
     * @todo
     *
     * @returns {boolean}
     */
    hasErrors() {
      this.form.age = parseInt(this.form.age);

      if (this.form.age < 18 || this.form.age > 100) {
        this.errorMessage = 'Invalid age';
        return true;
      }

      return false;
    },

    async submit() {
      const hasErrors = this.hasErrors();

      if (hasErrors) {
        return;
      }

      const r = await this.$store.dispatch('updateUserProfile', this.form);

      if (r.success) {
        document.querySelector('#btnClose').click();
        this.$emit('saved');
      } else {
        console.log('error', r);
      }
    },

    resetForm() {
      this.form = {...this.currentChatUser?.profile};
      this.form.hobbies = [...this.currentChatUser.hobbies.map(e => {
          return e.hobby_key;
      })];
    },
  },
};
</script>

<style scoped>
</style>
